import { Component, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { BlockchainAuditAssetResponse } from "src/app/model/BlockchainAuditAssetResponse";

@Component({
  selector: "app-blockchain-audittrail",
  templateUrl: "./blockchain-audittrail.component.html",
  styleUrls: ["./blockchain-audittrail.component.scss"],
})
export class BlockchainAuditTrailComponent implements OnInit {

  auditTrailList: BlockchainAuditAssetResponse[];
  
  constructor(
    private modalCtrl: ModalController,
  ) {}

  ngOnInit(): void {
    
  }

  stringify(str: any) {
    console.log('metadata', str);
    console.log('metadata str', JSON.stringify(str));
    return JSON.stringify(str);
  }

  cancel() {
    return this.modalCtrl.dismiss(null, "cancel");
  }
}
